// Angular dependencies.
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// Store
import { Store } from '@ngrx/store';
import { AppState, RestoreCreepsAction } from './store.module';

// Rxjs dependencies
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import { Observable } from 'rxjs/Observable';

// App dependencies.
import { Creep } from './creep';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'Power Planner';

  public creeps$: Observable<Creep[]>;

  constructor(
    private _store: Store<AppState>,
    private _route: ActivatedRoute,
    private _router: Router
  ) {

  }

  ngOnInit() {
    const subscriber$ = this._route
      .queryParams
      // TODO: why two executes?
      .filter(({ creeps }) => !!creeps)
      .map(({ creeps }) => creeps.split(','))
      .do((creeps) => {
        creeps = creeps.map((creepStr: string) => Creep.fromString(creepStr));

        this._store.dispatch(new RestoreCreepsAction(creeps));

        // TODO: need something do with it.
        subscriber$.unsubscribe();
      })
      .subscribe();


    // console.log(this._store);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/app.component.ts